module.exports = __webpack_public_path__ + "products/bump-marketing-icon-f4b3b9d01de2c3b8a2ce99192f00765f.svg";


//////////////////
// WEBPACK FOOTER
// ./images/products/bump-marketing-icon.svg
// module id = qMES
// module chunks = 20